<template>
    <el-carousel :interval="3000"  class="sliders" :height="clientHeight"  :autoplay="true" >
      <el-carousel-item 
      v-for="index in 4" :key="index" 
      class="slider-item"
      :style="{backgroundImage: `url('https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/home_${index}.png')`}"
      >
     </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
  data() {
    return {
      clientHeight: `${document.documentElement.clientWidth * (913 / 1920)}px`,
      banners: [
        {
          name: 'home_1',
          style: {
            backgroundImage: `url('https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/home_1.png')`,
            backgroundSize: '100% %',
            height: '100%',
          },
        },
      ],
    };
  },
  methods: {
    
  },
  mounted() {
    // 然后监听window的resize事件．在浏览器窗口变化时再设置下背景图高度．
    const that = this;
    window.onresize = function temp() {
      // that.clientWidth = `${document.documentElement.clientHeight}px`;
      that.clientHeight = `${document.documentElement.clientWidth * (913 / 1920)}px`;
    };
  },
};
</script>


<style lang="less" scoped>
.slider-item {
  background-size: 100% auto !important;
}
.sliders{
  overflow: hidden;
  .content{
      z-index:5;
      color: white;
      position  : absolute;
      top       : 50%;
      left      : 50%;
      transform : translate(-50%,-50%);
      h1{
        font-size: 120px;
        font-weight: 800;
        margin: 0px;
        text-align: center;
      }
      h2{
        font-size: 60px;
        font-weight: 600;
        margin: 0px;
        text-align: center;

      }
    }

  .el-carousel__item {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow:hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue